import {getCooperativeList,
    getCooperativeQuesList,
    saveCooperativeQues,
    getCooperativeBankList,
    getCooperativeCallMe,
    cooperativeLike,
    getCooperativeAllUserList,
    getCooperativeAllList,
    getCooperativeAllQuesList,
    getCooperativeWeekInfo,
    getCooperativeAllUserInterviewList,
    cooperativePrizeList,
    cooperativePrizeDetail,
    cooperativeMyPrizeList,
    cooperativeMyPrizeBonusesDate,
    modifyPaperAnswerRelationSort,
    savemodityWeekAfterWeek,
    saveRemarkInfo,
    saveIsDissentInfo,
    delPaperAnswerRelation,
    getKpiMonthRanking,
    saveKpiRemark,
    getKpiMonthsTotal,
    cooperativeComment,cooperativeCallBackSave,getQuarterKpiQues,saveQuarterKpiQues,saveModityPaperStatus,delQuarterKpiQues,getQuarterKpiQuesId,saveCheckWeekAfterWeek,updateFinishFlag,
    getSubordinateUnConfirmReport,getPaperPage,getWeekEndUnfinshList,getWeekEndfinshList,returnQues,savePaperRead,getWeekTaskList,getDepartsCascader,getOKRList,getKrTableTitle,saveAnswerRelation,

    } from '@/api/api'


const state={
    indexNavTabList:[],
    indexSectionList:[],
    indexPlatformList:[],
    indexModuleTabList:[],
    indexModuleList:[],
};
const getters = {

};
const actions = {
    initCooperativeList({commit,state},param){
        return new Promise((resolve) => {
            getCooperativeList(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    initAllUserInterviewList({commit,state},param){
        return new Promise((resolve) => {
            getCooperativeAllUserInterviewList(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    initCooperativeQues({commit,state},param){
        return new Promise((resolve) => {
            getCooperativeQuesList(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    initCooperativeBankList({commit,state},param){
        return new Promise((resolve) => {
            getCooperativeBankList(param).then((res) => {
                if(res.data.status == 200){
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })

    },
    initCooperativeCallMe({commit,state},param){
        return new Promise((resolve) => {
            getCooperativeCallMe(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    initCooperativeAllUserList({commit,state},param){
        return new Promise((resolve) => {
            getCooperativeAllUserList(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    initCooperativeAllList({commit,state},param){
        return new Promise((resolve) => {
            getCooperativeAllList(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    initCooperativeAllQuesList({commit,state},param){
        return new Promise((resolve) => {
            getCooperativeAllQuesList(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    initCooperativePrizeList({commit,state},param){
        return new Promise((resolve) => {
            cooperativePrizeList(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    initCooperativeMyPrizeList({commit,state},param){
        return new Promise((resolve) => {
            cooperativeMyPrizeList(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    getCooperativePrizeDetail({commit,state},param){
        return new Promise((resolve) => {
            cooperativePrizeDetail(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    cooperativeLikeOrCancle({commit,state},param){
        return new Promise((resolve) => {
            cooperativeLike(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    cooperativeCommentInfo({commit,state},param){
        return new Promise((resolve) => {
            cooperativeComment(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    cooperativeWeekInfo({commit,state},param){
        return new Promise((resolve) => {
            getCooperativeWeekInfo(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    submitCooperativeQues({commit,state},param){
        return new Promise((resolve) => {
            saveCooperativeQues(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    cooperativeCallBack({commit,state},param){
        return new Promise((resolve) => {
            cooperativeCallBackSave(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    cooperativePrizeBonusesDate({commit,state},param){
        return new Promise((resolve) => {
            cooperativeMyPrizeBonusesDate(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    getQuarterKpiQuesInfo({commit,state},param){
        return new Promise((resolve) => {
            getQuarterKpiQues(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    saveQuarterKpiQuesInfo({commit,state},param){
        return new Promise((resolve) => {
            saveQuarterKpiQues(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    delQuarterKpiQuesInfo({commit,state},param){
        return new Promise((resolve) => {
            delQuarterKpiQues(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },getQuarterKpiQuesIdInfo({commit,state},param){
        return new Promise((resolve) => {
            getQuarterKpiQuesId(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    saveModityPaperStatusInfo({commit,state},param){
        return new Promise((resolve) => {
            saveModityPaperStatus(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    saveCheckWeekAfterWeekInfo({commit,state},param){
        return new Promise((resolve) => {
            saveCheckWeekAfterWeek(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    modifyPaperAnswerRelationSortInfo({commit,state},param){
        return new Promise((resolve) => {
            modifyPaperAnswerRelationSort(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    savemodityWeekAfterWeek({commit,state},param){
        return new Promise((resolve) => {
            savemodityWeekAfterWeek(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    saveRemarkInfo({commit,state},param){
        return new Promise((resolve) => {
            saveRemarkInfo(param).then((res) => {
                if(res.data.status == 200){
            resolve(res.data.value)
        }
    })
    })
    },

    saveIsDissentInfo({commit,state},param){
        return new Promise((resolve) => {
            saveIsDissentInfo(param).then((res) => {
                if(res.data.status == 200){
            resolve(res.data.value)
        }
    })
    })
    },

    getKpiMonthsTotal({commit,state},param){
        return new Promise((resolve) => {
            getKpiMonthsTotal(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    getKpiMonthRanking({commit,state},param){
        return new Promise((resolve) => {
            getKpiMonthRanking(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    saveKpiRemark({commit,state},param){
        return new Promise((resolve) => {
            saveKpiRemark(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    updateFinishFlag({commit,state},param){
        return new Promise((resolve) => {
            updateFinishFlag(param).then((res) => {
                if(res.data.status == 200){
                    resolve(res.data.value)
                }
            })
        })

    },
    getSubordinateUnConfirmReport({commit,state},param){
        return new Promise((resolve) => {
            getSubordinateUnConfirmReport(param).then((res) => {
                if(res.data.status == 200){
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })

    },
    getPaperPage({commit,state},param){
        return new Promise((resolve) => {
            getPaperPage(param).then((res) => {
                if(res.data.status == 200){
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })

    },
    getWeekEndUnfinshList({commit,state},param){
        return new Promise((resolve) => {
            getWeekEndUnfinshList(param).then((res) => {
                if(res.data.status == 200){
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })

    },
    getWeekEndfinshList({commit,state},param){
    return new Promise((resolve) => {
        getWeekEndfinshList(param).then((res) => {
            if(res.data.status == 200){
                console.log(res.data.value)
                resolve(res.data.value)
            }
            })
        })
    },
    returnQues({commit,state},param) {
        return new Promise((resolve) => {
            returnQues(param).then((res) => {
                if (res.data.status == 200) {
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })
    },
    savePaperRead({commit,state},param) {
        return new Promise((resolve) => {
            savePaperRead(param).then((res) => {
                if (res.data.status == 200) {
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })
    },
    getWeekTaskList({commit,state},param) {
        return new Promise((resolve) => {
            getWeekTaskList(param).then((res) => {
                if (res.data.status == 200) {
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })
    },
    getDepartsCascader({commit,state},param) {
        return new Promise((resolve) => {
            getDepartsCascader(param).then((res) => {
                if (res.data.status == 200) {
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })
    },
    getOKRList({commit,state},param) {
        return new Promise((resolve) => {
            getOKRList(param).then((res) => {
                if (res.data.status == 200) {
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })
    },
    getKrTableTitle({commit,state},param) {
        return new Promise((resolve) => {
            getKrTableTitle(param).then((res) => {
                if (res.data.status == 200) {
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })
    },
    saveAnswerRelation({commit,state},param) {
        return new Promise((resolve) => {
            saveAnswerRelation(param).then((res) => {
                if (res.data.status == 200) {
                    console.log(res.data.value)
                    resolve(res.data.value)
                }
            })
        })
    },
};
const mutations = {

};
export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/cooperativeData.js